/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mass of solute`)
};

const es_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masa de soluto`)
};

const de_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse des gelösten Stoffes`)
};

const nl_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa opgeloste stof`)
};

const fr_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masse de soluté`)
};

const it_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa di soluto`)
};

const pt_br2_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa do soluto`)
};

const pt_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa de soluto`)
};

const ja_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶質の質量`)
};

const zh_pctsol_field_mass = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`溶质质量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_field_mass = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_field_mass(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_field_mass", locale)
	if (locale === "en") return en_pctsol_field_mass(inputs)
	if (locale === "es") return es_pctsol_field_mass(inputs)
	if (locale === "de") return de_pctsol_field_mass(inputs)
	if (locale === "nl") return nl_pctsol_field_mass(inputs)
	if (locale === "fr") return fr_pctsol_field_mass(inputs)
	if (locale === "it") return it_pctsol_field_mass(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_field_mass(inputs)
	if (locale === "pt") return pt_pctsol_field_mass(inputs)
	if (locale === "ja") return ja_pctsol_field_mass(inputs)
	return zh_pctsol_field_mass(inputs)
};